import { PORTAL_API, PORTAL_WWW, PORTAL_IMAGES_ENDPOINT } from '../../../services/constants'

const authUrl = 'https://portalauth-lsmfqpbnmt.now.sh/auth';
const authSecret = '@Portal_17_Web17';
const apiUrl = 'https://portalua-server-qa6yq4mpm.now.sh/api';
const baseUrl = 'https://www.ua.pt';
const hasHash = '#';

const views = {
  root: 'root',
  cooperate: 'cooperate',
  education: 'education',
  public: 'public',
  index: 'index',
  internal: 'internal',
  international: 'international',
  live: 'live',
  investigation: 'investigation',
};

// PORTAL UA MICROSERVICES APIS URLS
const portalAPI = PORTAL_API
const portalWWW = PORTAL_WWW;
const imageAPI = PORTAL_IMAGES_ENDPOINT;

export {
  authUrl,
  authSecret,
  apiUrl,
  portalAPI,
  baseUrl,
  hasHash,
  views,
  portalWWW,
  imageAPI,
};
